import { render, staticRenderFns } from "./LogoutScreen.vue?vue&type=template&id=92d6aa9c&scoped=true&"
import script from "./LogoutScreen.vue?vue&type=script&lang=ts&"
export * from "./LogoutScreen.vue?vue&type=script&lang=ts&"
import style0 from "./LogoutScreen.vue?vue&type=style&index=0&id=92d6aa9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d6aa9c",
  null
  
)

export default component.exports